<template>
  <div class="article-body-text">
    <div class="text">
      <div class="wysiwyg" v-html="text"></div>
      <p v-if="author" class="author">Words by {{ author }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleBodyText",
  props: {
    text: {
      type: String,
      required: true,
    },
    author: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.article-body-text {
  margin: 0 0 60px 0;
  padding: 0 20px;

  @include respond-above(md) {
    margin: 0 0 80px 0;
    padding: 0;
  }
}

.text {
  @include respond-above(md) {
    column-count: 2;
    column-gap: 40px;
    margin: 0 auto;
    max-width: 976px;
  }
}

.author {
  @include t__utility-label-30;
  margin: 15px 0 0 0;

  @include respond-above(md) {
    margin: 20px 0 0 0;
  }
}

.wysiwyg :deep() {
  color: $color-grey-dark;
  @include t__editorial-body-10;

  @include respond-above(md) {
    @include t__editorial-body-20;
  }

  h4 {
    @include t__editorial-headline-10;
    margin-bottom: 10px;

    @include respond-above(md) {
      @include t__editorial-headline-20;
    }
  }

  p {
    margin-bottom: 15px;
  }

  *:last-child {
    margin-bottom: 0;
  }
}
</style>
